export default "__VITE_ASSET__DfbjFZdQ__"